/**
 * Reminder Response Type
 */
export enum ReminderResponseType {
  /**
   * Yes or No
   */
  YesOrNo = 'yes-or-no',

  /**
   * Ok
   */
  OK = 'ok',
}
